import { RouteRecordRaw } from 'vue-router';

const EmptyLayout = () => import('@/shared/layouts/pages/EmptyLayout/index.vue');
const LocalTransaction = () => import('@/modules/transaction/pages/TransactionFlow/index.vue');

const localTransaction: Array<RouteRecordRaw> = [
  {
    path: '/local-transaction',
    name: 'local-transaction',
    redirect: {
      name: 'local-transaction-index',
    },
    component: EmptyLayout,
    children: [
      {
        path: '',
        name: 'local-transaction-index',
        component: LocalTransaction,
      },
    ],
  },
];

export default localTransaction;
